const autoNgTemplateLoaderTemplate1 = require('./kube-edit-custom-template-view.html');

import controller from './kube-edit-custom-template-view.controller.js';

export const kubeEditCustomTemplateView = {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller,
};
